import { Button, ClassNameProps, If, makeClassName, Modal, ModalProps, Row, StyleProps } from "@hex-insights/core";
import { Icon } from "../../../../Components/Icon";
import { useRecordViewOnMount } from "../../../../Utilities";
import { AnnouncementDetailDisplay, DetailDisplayAnnouncement } from "../DetailDisplay";
import styles from "./styles.module.css";

export type ModalAnnouncement = DetailDisplayAnnouncement;

export type AnnouncementModalProps = {
	announcement: ModalAnnouncement;
	isNew?: boolean;
	noReactions?: boolean;
	isPreview?: boolean;
	withBackButton?: boolean;
	backButtonText?: string;
} & Pick<ModalProps, "ifRef" | "onClose"> &
	Partial<ClassNameProps & StyleProps>;

export function AnnouncementModal({
	announcement,
	isNew,
	noReactions = false,
	withBackButton = false,
	isPreview = false,
	backButtonText = "Back to Announcements",
	ifRef,
	onClose,
	className,
	style,
}: AnnouncementModalProps) {
	useRecordViewOnMount(announcement.id);

	return (
		<Modal
			ifRef={ifRef}
			onClose={onClose}
			className={makeClassName(styles["announcement-modal"], className)}
			style={style}
		>
			<If condition={withBackButton}>
				<Modal.Header>
					{onClose && (
						<Button variant="link" size="small" onClick={onClose}>
							<Row justify="spaced-start" align="center" horizontalSpacing="0.375rem">
								<Icon.ArrowLeft size={14} /> {backButtonText}
							</Row>
						</Button>
					)}
				</Modal.Header>
			</If>
			<Modal.Body style={{ paddingTop: withBackButton ? 0 : undefined }}>
				<AnnouncementDetailDisplay
					announcement={announcement}
					isNew={isNew}
					withReactions={!noReactions}
					editable
					isPreview={isPreview}
				/>
			</Modal.Body>
		</Modal>
	);
}
